<template>

    <div class="modal fade" :id="getKey" tabindex="-1" role="dialog" v-if="dataLoaded">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><i class="mdi mdi-close"></i></span></button>
                    <h4 class="modal-title">Collega zoeken</h4>
                </div>
                <div class="modal-body text-right">
                    <button class="btn btn-primary btn-sm" type="button" @click="closeOfficeSearch()">Geselecteerde collega's gebruiken</button>
                </div>
                <div class="modal-body no-padding">
                    <table class="table table-striped" v-if="getOfficeUsers.length > 0">
                        <thead>
                            <tr>
                                <th>Naam</th>
                                <th class="col-sm-2">Selecteer</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="user in getOfficeUsers">
                                <td><label :for="'checkuser-' + user.uuid">{{ user.fullname }}</label></td>
                                <td>
                                    <input type="checkbox" :id="'checkuser-' + user.uuid" v-model="users" :value="user.uuid" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="modal-body text-right">
                    <button class="btn btn-primary btn-sm" type="button" @click="closeOfficeSearch()">Geselecteerde collega's gebruiken</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import {mapGetters,mapActions} from 'vuex';

    export default {

        computed:{

            ...mapGetters([
                'dataLoaded',
                'getOfficeUsers',
            ]),

            getKey() {
                return 'searchOfficeModal-' + this.uniquekey;
            },

        },

        data() {
            return {
                uniquekey:'',
                users:[],
            }
        },

        methods: {

            closeOfficeSearch() {
                this.$emit("selected-users", JSON.parse(JSON.stringify(this.users)));
                $('#' + this.getKey).modal('hide');
                this.users = [];
            },

            openOfficeSearch() {
                $('#' + this.getKey).modal('show');
            },

        },

        mounted() {
            this.uniquekey = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        },

        name: "OfficeSelector",

    }

</script>
